import { defineComponent as _defineComponent } from 'vue'

import { getCurrentInstance, inject, onMounted, PropType } from 'vue';
import {
  commonProps,
  FabricExposition,
  injectionKey,
} from '@/core/components/data-display/Fabric/fabric.shared';
import { fabric } from 'fabric';
import { useFabricObject } from '@/core/components/data-display/Fabric/fabric.hooks';
import { Deferred } from '@/utils/promise';
import { renderObject } from '@/core/components/data-display/Fabric/fabric';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkFabricRect',
  props: {
  ...commonProps,
  options: {
    type: Object as PropType<fabric.IRectOptions>,
    default: () => ({}),
  },
},
  setup(__props, { expose }) {

const props = __props



const fabricInjection = inject<FabricExposition>(injectionKey);
const deferredObject = Deferred<fabric.Rect>();
const vm = getCurrentInstance();

let rect: fabric.Rect;
useFabricObject(() => rect, props);

const createObject = (): fabric.Rect => {
  const object = new fabric.Rect(props.options);
  object.set('strokeWidth', 0);
  return object;
};

onMounted(() => {
  const canvas = fabricInjection?.getCanvas();
  deferredObject.promise.then((object) => renderObject({
    object,
    canvas,
    deferredObject,
    vm,
  }));
  rect = createObject();
  deferredObject.resolve(rect);
});

expose({
  deferredObject,
});

return (_ctx: any,_cache: any) => {
  return null
}
}

})